/* eslint-disable max-lines */
/* eslint-disable sort-keys */
export const MOCK_PRODUCT_LINKS = [
    {
        name: 'Страна',
        type: 'country',
        url: '/catalog/vino/filter/country-frantsiya/',
        value: 'Франция',
    },
    {
        name: 'Цвет',
        type: 'color',
        url: '/catalog/vino/filter/country-frantsiya/',
        value: 'белое',
    },
    {
        name: 'Тип',
        type: 'type',
        url: '/catalog/vino/filter/country-frantsiya/',
        value: 'сухое',
    },
    {
        name: 'Объем',
        type: 'capacity',
        url: '/catalog/vino/filter/country-frantsiya/',
        value: '0.75 л',
    },
];
